exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n\n#btn-dropdown-sprintSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.icon-position {\n  padding-top: 5px; }\n\n::ng-deep .modal .modal-footer {\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/edit-item-dialog/edit-item-dialog.component.scss
// module id = ../../../../../src/app/components/edit-item-dialog/edit-item-dialog.component.scss
// module chunks = main